'use client';

import { useTranslations } from 'next-intl';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { CatDrawer } from 'blocks-nextjs/blocks-react/components/Drawer';
import styles from './availability-by-source-drawer.module.scss';
import { v4 } from 'uuid';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { availabilityBySourceDrawerTypes } from './types';
import AvailabilityBySourceContent from './availability-by-source-content';
import cx from 'classnames';
import {
  Conditional,
  useBreakpoint,
  useDrawer
} from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { BlocksCloseEvent } from '@blocks-web-components/events/blocks-close';

const AvailabilityBySourceDrawer = ({
  sourcingDetails,
  address,
  isPDPPage = false,
  showAvailabilityAsBottomDrawer = false,
  isPCC_PDP_headerUpdateMobileView = false
}: availabilityBySourceDrawerTypes) => {
  const t = useTranslations();
  const { openDrawer, closeDrawer, isDrawerOpen } = useDrawer();
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const shouldshowAvailabilityAsBottomDrawer =
    showAvailabilityAsBottomDrawer && isPCC_PDP_headerUpdateMobileView && !isMD;

  const handleCloseDrawer = (e?: BlocksCloseEvent) => {
    e?.stopPropagation();
    e?.preventDefault?.();
    closeDrawer();
  };

  const drawerContent = () => (
    <>
      <div slot="header" className="cat-u-theme-typography-title-sm">
        {t('PDP_SRC_AVAILABILITY_DRAWER')}
      </div>

      <div className="cat-u-margin-left-sm">
        {sourcingDetails?.map(
          ({ sequence, availStoreList, availabilityMessage }) => {
            const hasAvailabilityMessage = !isEmpty(availabilityMessage);
            return (
              <div
                className="cat-u-margin-bottom-md"
                key={`avail-by-source-${v4()}`}
              >
                <AvailabilityBySourceContent
                  availStoreList={availStoreList}
                  sequence={sequence}
                  hasAvailabilityMessage={hasAvailabilityMessage}
                  address={address}
                  availabilityTitle={availabilityMessage}
                />
              </div>
            );
          }
        )}
      </div>
    </>
  );

  return (
    <div
      className={cx(
        isPDPPage && isPCC_PDP_headerUpdateMobileView && !isMD
          ? 'cat-u-margin-top-md'
          : 'cat-u-margin',
        {
          'd-flex justify-content-end':
            isPDPPage && isPCC_PDP_headerUpdateMobileView && !isMD
        }
      )}
    >
      <CatButton
        onClick={openDrawer}
        variant={
          isPDPPage && isPCC_PDP_headerUpdateMobileView && !isMD
            ? 'inline'
            : 'ghost'
        }
        className={styles['avail-by-source__btn']}
        data-testid="avail-by-source-button"
      >
        {isPDPPage && isPCC_PDP_headerUpdateMobileView && !isMD
          ? t('SHOW_AVAILABILITY_BY_SOURCE_TITLECASE')
          : t('AVAIL_STANDARD_AVAILABILITY_SOURCE')}
      </CatButton>
      <Conditional test={!shouldshowAvailabilityAsBottomDrawer}>
        <CatDrawer
          isActive={isDrawerOpen && !shouldshowAvailabilityAsBottomDrawer}
          onBlDrawerClose={handleCloseDrawer}
          data-testid="warranty-information-drawer"
        >
          {drawerContent()}
        </CatDrawer>
      </Conditional>
      <Conditional test={shouldshowAvailabilityAsBottomDrawer}>
        <CatDrawer
          isActive={isDrawerOpen && shouldshowAvailabilityAsBottomDrawer}
          onBlDrawerClose={handleCloseDrawer}
          orientation="bottom"
          verticalMaxHeight="large"
          data-testid="warranty-information-drawer-updated"
          className={cx({
            [styles['avail-by-source_drawer']]:
              shouldshowAvailabilityAsBottomDrawer
          })}
        >
          {drawerContent()}
        </CatDrawer>
      </Conditional>
    </div>
  );
};

export default AvailabilityBySourceDrawer;
